import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
    return (
        <footer className="mt-12 py-8 border-t border-gray-100 bg-gray-50">
            <div className="container mx-auto px-4">
                <div className="flex justify-center items-center">
                    <div className="text-center">
                        <div className="flex items-center justify-center">
                            <motion.div
                                className="w-8 h-8 rounded-lg bg-gradient-to-br from-primary to-tertiary flex items-center justify-center mr-2"
                                whileHover={{ rotate: 10, scale: 1.1 }}
                                transition={{ type: 'spring', stiffness: 400, damping: 10 }}
                            >
                                <span className="text-white font-bold text-sm">M</span>
                            </motion.div>
                            <span className="text-lg font-semibold">
                                <span className="primary-gradient">MCP</span>
                                <span className="text-gray-800">Tool</span>
                            </span>
                        </div>
                        <p className="text-sm text-gray-600 mt-2">
                            Curated MCP Server Navigation
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;